import { useSelector } from 'react-redux';
import { selectPublicationRestrictionType } from '../../../../../../reducers/v2/paidPublication/selectors';
import React from 'react';
import { restrictionTypeToComponent } from './restrictionTypeToComponent';

export const Restrictions = (): React.ReactElement | null => {
  const restrictionType = useSelector(selectPublicationRestrictionType);

  if (!restrictionType) {
    return null;
  }

  return restrictionTypeToComponent[restrictionType];
};
